<template>
    <div name="add-privacy-use" class="wrapper">
        <div class="header" v-if="property.back === 'true' || property.back === true">
            <div class="button-area" @click="back">
                <img class="back" src="../../assets/left_pointing_arrow.png" />
            </div>
            <span>개인정보 제3자 제공 동의서</span>
        </div>
        <h2>개인정보 제3자 제공 동의서</h2>
        <span>
            솔닥 주식회사(이하 "회사“)는 DTx 전문 플랫폼 ‘슬립큐’와의 업무 제휴를 통한 DTx수면장애 서비스 제공을 위하여 해당 서비스를 이용하는 정보주체의 개인정보를 제3자에게 제공할 수 있습니다. DTx수면장애 서비스 이용과 관련하여 정보주체 본인의 개인정보를 제3자에게 제공하고자 하는 경우에는 ⌜개인정보보호법⌟ 등 관계 법령에 따라 본인의 동의가 필요합니다.<br><br>
            회사는 DTx수면장애 서비스 제공을 위하여 아래와 같이 회원의 개인정보를 제3자에게 제공할 수 있습니다. 회원은 아래 내용을 충분히 이해하고, 이에 동의할 경우에만 해당 서비스를 이용할 수 있습니다.
        </span>
        <table border="1">
            <tbody>
                <tr>
                    <td>제공받는 자</td>
                    <td>제공 목적</td>
                    <td>제공 항목</td>
                    <td>제공받는 자의 보유 및 이용기간</td>
                </tr>
                <tr>
                    <td>슬립큐</td>
                    <td>슬립큐 앱 설치 및 이용 안내를 위한 문자(SMS) 발송</td>
                    <td>이름, 연락처</td>
                    <td>슬립큐 서비스 회원 탈퇴 및 이용계약 종료 시 또는 DTx수면장애 서비스 종료[1*]시</td>
                </tr>
            </tbody>
        </table>
        <span>
            [1*] 위 보유 기간에서의 "DTx수면장애 서비스 종료일"이란 회원이 “DTx수면장애 서비스 동의 해지를 하였거나, 서비스 이용을 종료한 날”을 말합니다. 
            DTx수면장애 서비스 종료일 후에는 회원이 개인정보 제3자 제공에 관한 동의를 철회한 것으로 보아 슬립큐에 그 사실을 통지하고 지체없이 파기 처리하도록 합니다. 단 전자상거래법 시행령 제6조에 따른 소비자 민원 및 분쟁 처리 내역, 표시・광고, 계약내용 및 이행 등 거래기록에 대한 법령상 보존 의무가 있는 경우에는 해당 의무 이행을 위한 목적으로 관계법령에서 정한 기간 동안 보관됩니다.<br><br><br>
            ※ 이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 다만 동의 거부 시 해당 서비스를 이용하실 수 없습니다.
        </span>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'addPrivacyUse',
    computed: mapState(['property']),
    methods: {
    back: function()
        {
            window.history.go(-1);
        }
    }
}
</script>

<style scoped>
    .title {
        font-size: 18px;
    }
    .label {
        font-size: 15px;
        color: gray;
    }
    .list {
        display: flex;
        flex-direction: column;
        gap: 3px;
        margin-top: 10px;
    }
    .link {
        text-decoration: underline;
        cursor: pointer;
        color: blue;
        font-size: 15px;
    }
    .header{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        font-weight: 500;
        height: 35px;
    }
    .back {
        width: 22px;
    }
    .button-area {
        position: absolute;
        left: 0;
        width: 35px;
        height: 35px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
    }
     .wrapper {
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      margin: 15px 0 15px 0;
      
    }
    th, td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    }
    th {
      background-color: #f4f4f4;
      font-weight: bold;
    }
    td {
      background-color: #ffffff;
    }
    th:nth-child(1), td:nth-child(1) {
      width: 16.7%; /* 1 */
    }
    th:nth-child(2), td:nth-child(2) {
      width: 23.3%; /* 1.4 */
    }
    th:nth-child(3), td:nth-child(3) {
      width: 33.3%; /* 2 */
    }
    th:nth-child(4), td:nth-child(4) {
      width: 26.7%; /* 1.2 */
    }
</style>


// WEBPACK FOOTER //
// src/pages/innovation/AddPrivacyUse.vue